export const dateFormatter = (date: Date | null): string => {
  if (!date) {
    return '';
  }
  return `${String(date.getFullYear()).padStart(4, '0')}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
};

export const toLocalDate = (dateString: string | undefined): Date | null => {
  if (!dateString) return null;

  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};
